import { render, staticRenderFns } from "./NationalCode.vue?vue&type=template&id=2d8f1328&"
import script from "./NationalCode.vue?vue&type=script&lang=js&"
export * from "./NationalCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports